import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

export const onEditNodeTriggerLoadPeopleInsights = store.effects.create(
  (feature: Feature) =>
    feature.actions.editNode.observe().pipe(
      rxjs.filter(action => TypeChecker.isNullish(action.data.edits)),
      rxjs.map(action => {
        const {
          data: { chartId, id },
        } = action

        if (TypeChecker.isNullish(id)) {
          throw new Error('Node ID is required to load people insights')
        }

        return feature.actions.loadPeopleInsights
          .from(action)
          .create({ chartId, id })
      }),
    ),
)
